import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { DraggableSplit } from '../DraggableSplit/DraggableSplit';
import { PDFViewerPanel } from '../PDFViewerPanel/PDFViewerPanel';
import { ProjectFiles } from '../ProjectFiles/ProjectFiles';
import { FileViewerPanel } from '../FileViewerPanel/FileViewerPanel';
export const DealChat_NoChat = observer(() => {
    const [fileData, setFileData] = useState({
        url: null,
        displayName: null
    });

    const store = useStore();

    const requestSeeFile = (fileUrl: string, displayName: string) => {
        setFileData({ url: fileUrl, displayName: displayName });
    };
    useEffect(() => {
        if (store.selectedReportId) {
            const pdfViewUrl = store.query.value('pdfViewUrl');
            if (pdfViewUrl != 'N/A') {
                requestSeeFile(
                    store.query.value('pdfViewUrl'),
                    store.selectedReportId
                );
            } else {
                const projectFilesRaw = store.projectFiles?.files || {};
                const projectFileKeys = Object.keys(projectFilesRaw);
                if (projectFileKeys.length > 0) {
                    const fileUrl = projectFilesRaw[projectFileKeys[0]].url;
                    requestSeeFile(
                        fileUrl,
                        projectFilesRaw[projectFileKeys[0]].filename
                    );
                }
            }
        }
    }, [store.selectedReportId]);

    return (
        <DraggableSplit spaceBetween={30}>
            <ProjectFiles requestSeeFile={requestSeeFile} />
            <FileViewerPanel
                fileName={fileData.url}
                title_display={fileData.displayName}
            />
            {/* <ChatPanel /> */}
        </DraggableSplit>
    );
});
